import { Type } from 'class-transformer';
import { AccProjectRawDto } from '../../shared-acc-board-approval-module/_models/acc-project-raw-dto';

export class AccUpdateParameterDto {
    accItemId: number;

    @Type(() => AccProjectRawDto)
    projectData: AccProjectRawDto;

    updateCustomer: boolean;
}
